import { Component, ContentChild, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonIcons } from 'src/app/components/action-button/models/button-icons.enum';
import { JobDigitalLogFormRequest, JobDigitalLogOnDemandForm, DigitalLogProfileGroup, DigitalLogProfileGroupDetail } from 'src/app/models/digital-log/digital-log.model';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';

import * as moment from 'moment';
import { sortBy, orderBy } from 'lodash-es';
import { DigitalLogService } from 'src/app/services/sections/job/digital-log.service';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from 'src/app/components/toast/models/toast-type.enum';
import { Toast } from 'src/app/components/toast/models/toast.model';
import { DigitalLogHelper } from '../helpers/digital-log.helper';
import { Frequency, JobDigitalLogOfflineRange } from '@vitralogy/ng-digital-log';
import { HttpEventType } from '@angular/common/http';
import { NavigationActionButton } from 'src/app/components/navigation-bar/models/navigation-action-button.model';
import { MyWorkUrlResolver } from 'src/app/resolvers/my-work-url.resolver';
import { GenericModalComponent } from 'src/app/components/generic-modal/generic-modal.component';
import { Job } from 'src/app/models/job.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SiteNotesService } from 'src/app/services/sections/site-notes/site-notes.service';
import { AuthPage } from 'src/app/models/auth/auth-page.model';
import { UserService } from 'src/app/services/sections/shared/user.service';
import { UserAccountInfo } from 'src/app/models/user-account-info.model';
import { getDatePart } from 'src/app/services/helpers/date.helper';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { JobStatusTypes } from 'src/app/models/enum/job-status-types.enum';

@Component({
	templateUrl: './digital-log-form-requests.component.html',
	styleUrls: ['./digital-log-form-requests.component.scss', '../../../stylesheets/job-main.scss', '../../../stylesheets/job-actions.scss', '../../../stylesheets/job-inputs.scss', '../../../stylesheets/job-form.scss']
})
export class DigitalLogFormRequestsComponent implements OnInit, OnDestroy {	
	@ViewChild('emptyOnDemandLogsModal', { static: true }) public emptyOnDemandLogsModal: GenericModalComponent;
	@ViewChild('emptyConfigOnDemandLogsModal', { static: true }) public emptyConfigOnDemandLogsModal: GenericModalComponent;
	@ViewChild('missingOnDemandConfigProfileModal', { static: true }) public missingOnDemandConfigProfileModal: GenericModalComponent;
	@ViewChild('startMyWorkProgressModal', { static: true }) public startMyWorkProgressModal: GenericModalComponent;
	@ViewChild('clearRemainingWorkModal', { static: true }) public clearRemainingWorkModal: GenericModalComponent;
	@ViewChild('profileGroupsSelectionModal', { static: true }) public profileGroupsSelectionModal: GenericModalComponent;
	@ViewChild('missingConfigProfileModal', { static: true }) public missingConfigProfileModal: GenericModalComponent;
	@ViewChild('futureLogDateConfirmationModal', { static: true }) public futureLogDateConfirmationModal: GenericModalComponent;

	public actionableFormRequests: JobDigitalLogFormRequest[];
	public onDemandFormRequests: JobDigitalLogFormRequest[];
	public allFormRequests: JobDigitalLogFormRequest[];

	public job: Job;

	public onDemandForms: JobDigitalLogOnDemandForm[];
	public configOnDemandForms: JobDigitalLogOnDemandForm[];
	public profileGroups: DigitalLogProfileGroupDetail[];

	public customFormRequestsList: JobDigitalLogFormRequest[];
	public customFormRequestsListCopy: JobDigitalLogFormRequest[] = [];
	public customerPreferences: SettingsPreferences;

	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;
	public readonly ButtonIcons = ButtonIcons;
	public moment = moment;
	public self = this;
	public beginningOfTime = new Date(1970, 1, 1);

	public returnUrl: string = null;

	public isConfirmEnable: boolean;
	public isDeleteDisabled = false;
	public isLoading = false;
	public isOfflineRangeEditMode = false;
	public isSpecifiedDateEnabled = false;

	public isShowCompletedOnly$ = new BehaviorSubject<boolean>(null);

	public offlineRangeToBeDeleted: JobDigitalLogOfflineRange = null;
	public selectedDigitalLogForm: JobDigitalLogFormRequest = null;
	public searchForm: FormGroup;

	// Workaround for the fact that MatDrawer can not be accessed inside a template in a child component
	public openMatDrawer$ = new Subject<boolean>();

	public offlineRangeFormGroup: FormGroup;
	public inputForm: FormGroup;
	public disabledFormGroup: FormGroup;
	public confirmationFormGroup: FormGroup;

	public offlineRanges: JobDigitalLogOfflineRange[] = [];

	public navigationBarActions: Map<string, NavigationActionButton>;

	private unsubscriber$: Subject<void> = new Subject<void>();
	private dlFormsFilterKey: string = 'dl-forms-filter';
	private dlFormsCompletionStateKey: string = 'dl-forms-completion-state';

	public userAccountInfoModel: UserAccountInfo;
	public accountRouteUrls: Map<AuthPage, string>;
	private siteNotesUrl: string;

	public isReportSelectorVisible: boolean = false;
	public canConfigureRounds: boolean = false;
	public today = new Date();
	public startMyWorkProgress: {progressMessage: string, isWorkStarting: boolean, isWorkStarted: boolean, hasProfileOverlap: boolean, hasError: boolean};
	public workStartedMsg: string = 'Work Started!';
	public profileOverlapMsg: string = 'There are already forms created for your selection, do you want them set to today?';
	public workStartedWithNoChangesMsg: string = 'Make sure you complete the session before starting a new one!';
	public startMyWorkDeniedMsg = 'Work cannot be started for this job!';
	public startMyWorkErrorMsg: string = 'Unable to start your work. Please try again!';
	
	public clearRemainingWorkProgress: {progressMessage: string, isCleanInProgress: boolean, isCleanCompleted: boolean, hasError: boolean};
	public clearStartedMsg: string = 'You are about to complete work. Are you sure that you want to continue ?';
	public clearRemainingWorkErrorMsg: string = 'Unable to complete work. Please try again!';
	public clearRemainingWorkDeniedMsg: string = 'Work cannot be clear for this job!';

	public isJobCancelled = false;
	public onDemandFormsCount: number = 0;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private digitalLogService: DigitalLogService,
		private siteNotesService: SiteNotesService,
		private userService: UserService,
		private jwt: JwtHelperService
	) {
		this.accountRouteUrls = this.activatedRoute.snapshot.data.accountRouteUrls;
	}

	get startByWorkButtonLabel(): string {
		return this.job.customStartMyWorkActionName ?? 'Start My Work';
	}

	get clearRemainingWorkButtonLabel(): string {
		return this.job.customClearRemainingWorkActionName ?? 'Submit All';
	}
	ngOnInit(): void {
		this.navigationBarActions = GlobalSettingsService.navigationBarActions;

		this.job = (this.activatedRoute.snapshot.data.jobDetails || {}) as Job;
		this.isJobCancelled = this.job.statusId === JobStatusTypes.Canceled;
		this.returnUrl = sessionStorage.getItem('binder-rurl');

		this.actionableFormRequests = this.activatedRoute.snapshot.data.formRequests;

		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;
		this.onDemandForms = this.activatedRoute.snapshot.data.onDemandForms || [];
		this.configOnDemandForms = this.activatedRoute.snapshot.data.configOnDemandForms || [];
		this.profileGroups = this.activatedRoute.snapshot.data.profileGroups || [];
		this.userAccountInfoModel = this.activatedRoute.snapshot.data.accountInfo as UserAccountInfo;
		this.canConfigureRounds = this.activatedRoute.snapshot.data.canConfigureRounds as boolean;
		this.siteNotesUrl = this.activatedRoute.snapshot.data.accountRouteUrls.get(AuthPage.SiteNotes);
		this.onDemandFormsCount = this.activatedRoute.snapshot.data.onDemandFormsCount as number;
		this.customFormRequestsList = this.actionableFormRequests.filter(item => (!item.isCompleted && item.recurrenceFrequencyId === Frequency.OnDemand) || item.recurrenceFrequencyId !== Frequency.OnDemand);
		this.customFormRequestsListCopy = this.customFormRequestsList;

		if (MyWorkUrlResolver.isCustomerAllowed) {
			this.restoreFormsCompletionState();
			this.injectActionButtons();
		}
		this.checkNavigationBarActions();
		this.initializeSearchFormGroup();

		this.initializeOfflineRangeFormGroup();
		this.initializeInputFormGroup();
		this.initializeDisabledFormGroup();
		this.initializeConfirmationFormGroup();

		this.validateInput();
		this.bindFilters();

		GlobalSettingsService.isSecondaryLoaderLoading = false;
		GlobalSettingsService.isGlobalLoaderLoading = false;
	}

	ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();

		GlobalSettingsService.navigationBarActions.delete('add_onDemand_form');
		GlobalSettingsService.navigationBarActions.delete('configure_rounds');		
		GlobalSettingsService.navigationBarActions.delete('DL_completed_only');
		GlobalSettingsService.navigationBarActions.delete('site_notes_access_button');
		GlobalSettingsService.navigationBarActions.delete('generate_inspection_report');

		if (GlobalSettingsService.navigationBarActions.size === 1) {
			GlobalSettingsService.navigationBarActions.forEach(button => {
				button.isInDropdownMenu = false;
			});
		}
	}

	get showCompletedOnly(): boolean | null {
		return this.isShowCompletedOnly$.getValue();
	}

	get hasCustomReturnUrl(): boolean {
		return !!this.returnUrl;
	}

	public handleStartMyWork(event: any): void {
		if (!this.profileGroups || this.profileGroups.length === 0) {
			this.missingOnDemandConfigProfileModal.open();
			return;
		}

		if (this.profileGroups && this.profileGroups.length > 1) {
			this.profileGroupsSelectionModal.open();
			return;
		}

		const profileGroup = this.profileGroups && this.profileGroups.length === 1
			? this.profileGroups[0]
			: null;

		this.selectProfileGroup(profileGroup);
	}

	private startMyWork(selectedProfileGroupId?: number): void {
		this.startMyWorkProgress = {
			progressMessage: 'Starting your work...',
			isWorkStarting: true,
			isWorkStarted: false,
			hasProfileOverlap: false,
			hasError: false
		};
		this.startMyWorkProgressModal.open();
		this.digitalLogService.startMyWork(TokenHelper.getToken(this.activatedRoute), selectedProfileGroupId).subscribe(result => {
			// this.startMyWorkProgress.hasProfileOverlap = result.hasActiveFormRequests;
			this.startMyWorkProgress.isWorkStarting = false;
			if (result.hasActiveFormRequests) {
				//this.startMyWorkProgress.progressMessage = this.profileOverlapMsg;
				this.setMyWorkToToday(selectedProfileGroupId);
			}
			else {
				this.startMyWorkProgress.isWorkStarted = true;
				this.startMyWorkProgress.progressMessage = this.workStartedMsg;
			}
		}, error => {
			this.startMyWorkProgress.isWorkStarting = false;
			this.startMyWorkProgress.hasError = true;
			if (error.status === 401) {
				this.startMyWorkProgress.progressMessage = this.startMyWorkDeniedMsg;
			}
			else {
				this.startMyWorkProgress.progressMessage = this.startMyWorkErrorMsg;
			}
		});
	}

	public selectProfileGroup(profileGroup: DigitalLogProfileGroupDetail): void {
		this.profileGroupsSelectionModal.hide();
		// check if there are any forms for the selected profile group
		if (!!profileGroup && profileGroup.formsCount > 0) {
			this.startMyWork(profileGroup.digitalLogProfileGroupId);
		}
		else {
			this.missingConfigProfileModal.open();
		}
	}

	private restoreInlineFilters(): void {
		const filter = sessionStorage.getItem(this.dlFormsFilterKey);
		sessionStorage.removeItem(this.dlFormsFilterKey);
		if (!!filter) {
			const filterValue = JSON.parse(filter);
			const patch = {
				searchInput: filterValue?.searchInput
			}
			this.searchForm.patchValue(patch);			
		}
	}

	private restoreFormsCompletionState(): void {
		const showCompletedOnlyCached = sessionStorage.getItem(this.dlFormsCompletionStateKey);
		sessionStorage.removeItem(this.dlFormsCompletionStateKey);
		if (!!showCompletedOnlyCached) {
			this.isShowCompletedOnly$.next(JSON.parse(showCompletedOnlyCached));
		}
	}

	private cacheFilters(): void {
		const filterData = this.searchForm.getRawValue();
		sessionStorage.setItem(this.dlFormsFilterKey, JSON.stringify(filterData));
		const completionState = this.showCompletedOnly;
		if (!!completionState) {
			sessionStorage.setItem(this.dlFormsCompletionStateKey, completionState.toString());
		}
	}

	public navigateToForm(jobDigitalLogFormRequestId: number): void {
		this.cacheFilters();
		this.router.navigate([jobDigitalLogFormRequestId + '/form'], { relativeTo: this.activatedRoute });
	}

	public navigateToCalendar(jobDigitalLogFormRequestId: number): void {
		this.cacheFilters();
		this.router.navigate(['calendar'], { relativeTo: this.activatedRoute, queryParams: { r: jobDigitalLogFormRequestId } });
	}

	public selectDigitalLogForm(form: JobDigitalLogFormRequest): void {
		this.selectedDigitalLogForm = form;
		this.loadOfflineRanges(form.jobDigitalLogFormRequestId);
	}

	public setAsNotApplicable(jobDigitalLogFormRequest: JobDigitalLogFormRequest): void {
		const formData = this.inputForm.getRawValue();
		this.digitalLogService.setFormNotApplicable(TokenHelper.getToken(this.activatedRoute), jobDigitalLogFormRequest.jobDigitalLogFormRequestId, formData?.keepDataUpTo)
			.subscribe(() => {
				this.deleteFormByIndex(this.customFormRequestsList, jobDigitalLogFormRequest.jobDigitalLogFormRequestId);
				this.deleteFormByIndex(this.actionableFormRequests, jobDigitalLogFormRequest.jobDigitalLogFormRequestId);
				this.inputForm.reset();
				this.clearDate();
			}, () => {
				ToastService.pushToast({
					icon: 'error',
					text: 'Could not disable!',
					type: ToastType.Error
				} as Toast);
			});
	}

	get jobToken(): string{
		return TokenHelper.getToken(this.activatedRoute);
	}

	public loadOfflineRanges(jobDigitalLogFormRequestId: number): void {
		this.isLoading = true;

		this.digitalLogService.getOfflineRanges(TokenHelper.getToken(this.activatedRoute), jobDigitalLogFormRequestId)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(result => {
				this.isLoading = false;
				this.offlineRanges = result;
			});
	}

	public saveOfflineRange(): void {
		const model = this.offlineRangeFormGroup.getRawValue();

		if (!model.jobDigitalLogFormRequestId || !model.startDate || !model.endDate) {
			ToastService.pushToast({
				icon: 'error',
				text: 'Data is incomplete, could not save!',
				type: ToastType.Error
			} as Toast);

			return;
		}

		model.startDate = moment(model.startDate).parseZone().format('YYYY-MM-DD');
		model.endDate = moment(model.endDate).parseZone().format('YYYY-MM-DD');

		let request = of(null);

		if (!!model.jobDigitalLogFormOfflineRangeId) {
			const updatedRangeIndex = this.offlineRanges.findIndex(item => item.jobDigitalLogFormOfflineRangeId === model.jobDigitalLogFormOfflineRangeId);
			const oldRange = this.offlineRanges[updatedRangeIndex];

			const oldRangeYears = [...Array(moment(oldRange.endDate).year() - moment(oldRange.startDate).year() + 1)].map((_, index) => moment(oldRange.startDate).year() + index);
			const newRangeYears = [...Array(moment(model.endDate).year() - moment(model.startDate).year() + 1)].map((_, index) => moment(model.startDate).year() + index);

			const impactedYears = Array.from(new Set<number>([...oldRangeYears, ...newRangeYears]));

			request = this.digitalLogService.updateOfflineRange(TokenHelper.getToken(this.activatedRoute), model.jobDigitalLogFormRequestId, model, impactedYears);
		} else {
			const impactedYears = [...Array(moment(model.endDate).year() - moment(model.startDate).year() + 1)].map((_, index) => moment(model.startDate).year() + index);

			request = this.digitalLogService.saveOfflineRange(TokenHelper.getToken(this.activatedRoute), model.jobDigitalLogFormRequestId, model, impactedYears);
		}

		request
			.subscribe((rangeId) => {
				if (!!model.jobDigitalLogFormOfflineRangeId) {
					const rangeIndex = this.offlineRanges.findIndex(item => item.jobDigitalLogFormOfflineRangeId === model.jobDigitalLogFormOfflineRangeId);
					this.offlineRanges.splice(rangeIndex, 1);
					this.addRangeToList(model);
				} else {
					model.jobDigitalLogFormOfflineRangeId = rangeId;
					this.addRangeToList(model);
				}

				const formRequest = this.actionableFormRequests.find(item => item.jobDigitalLogFormRequestId === model.jobDigitalLogFormRequestId);
				formRequest.isDisabled = DigitalLogHelper.isWithinOfflineRange(moment().format('YYYY-MM-DD'), this.offlineRanges);

				this.openMatDrawer$.next(false);
				this.offlineRangeFormGroup.reset();
				this.resetConfirmationCheckbox();
			}, () => {
				ToastService.pushToast({
					icon: 'error',
					text: 'Save could not be completed!',
					type: ToastType.Error
				} as Toast);
				this.resetConfirmationCheckbox();
			});
	}

	public deleteOfflineRange(): void {
		if (!this.offlineRangeToBeDeleted) {
			return;
		}

		const impactedYears = [...Array(moment(this.offlineRangeToBeDeleted.endDate).year() - moment(this.offlineRangeToBeDeleted.startDate).year() + 1)]
			.map((_, index) => moment(this.offlineRangeToBeDeleted.startDate).year() + index);

		this.digitalLogService.deleteOfflineRange(
			TokenHelper.getToken(this.activatedRoute),
			this.offlineRangeToBeDeleted.jobDigitalLogFormRequestId,
			this.offlineRangeToBeDeleted.jobDigitalLogFormOfflineRangeId,
			impactedYears
		)
			.subscribe((event) => {
				if (event.type === HttpEventType.Response) {
					const formRequest = this.actionableFormRequests.find(item => item.jobDigitalLogFormRequestId === this.offlineRangeToBeDeleted.jobDigitalLogFormRequestId);

					const rangeIndex = this.offlineRanges.findIndex(item => item.jobDigitalLogFormOfflineRangeId === this.offlineRangeToBeDeleted.jobDigitalLogFormOfflineRangeId);
					this.offlineRanges.splice(rangeIndex, 1);

					formRequest.isDisabled = DigitalLogHelper.isWithinOfflineRange(moment().format('YYYY-MM-DD'), this.offlineRanges);

					this.openMatDrawer$.next(false);
					this.offlineRangeToBeDeleted = null;
				}
			}, () => {
				ToastService.pushToast({
					icon: 'error',
					text: 'Delete could not be completed!',
					type: ToastType.Error
				} as Toast);
			});
	}

	public clearOfflineRangesList(): void {
		this.selectedDigitalLogForm = null;
		this.unsubscriber$.next();
		this.offlineRanges = [];
		this.offlineRangeToBeDeleted = null;
		this.isOfflineRangeEditMode = false;
		this.offlineRangeFormGroup.reset();
	}

	public openOfflineRangeEdit(range?: JobDigitalLogOfflineRange): void {
		this.initializeOfflineRangeFormGroup(range);
		this.isOfflineRangeEditMode = true;
	}

	private initializeOfflineRangeFormGroup(range?: JobDigitalLogOfflineRange): void {
		if (!this.offlineRangeFormGroup) {
			this.offlineRangeFormGroup = new FormGroup({
				jobDigitalLogFormOfflineRangeId: new FormControl(range?.jobDigitalLogFormOfflineRangeId || null),
				jobDigitalLogFormRequestId: new FormControl(range?.jobDigitalLogFormRequestId || this.selectedDigitalLogForm?.jobDigitalLogFormRequestId || null, [Validators.required]),
				startDate: new FormControl((range?.startDate ? moment(range?.startDate).parseZone().toDate() : null) || null, [Validators.required]),
				endDate: new FormControl((range?.endDate ? moment(range?.endDate).parseZone().toDate() : null) || null, [Validators.required])
			});

			this.offlineRangeFormGroup.get('startDate').valueChanges
				.subscribe(startDate => {
					const endDate = this.offlineRangeFormGroup.get('endDate').value;

					if (moment(endDate).diff(moment(startDate), 'days') < 0) {
						this.offlineRangeFormGroup.get('endDate').reset();
					}
				});
		} else {
			this.offlineRangeFormGroup.patchValue({
				jobDigitalLogFormOfflineRangeId: range?.jobDigitalLogFormOfflineRangeId || null,
				jobDigitalLogFormRequestId: range?.jobDigitalLogFormRequestId || this.selectedDigitalLogForm?.jobDigitalLogFormRequestId || null,
				startDate: (range?.startDate ? moment(range?.startDate).parseZone().toDate() : null) || null,
				endDate: (range?.endDate ? moment(range?.endDate).parseZone().toDate() : null) || null,
			});
		}
	}

	private addRangeToList(range: JobDigitalLogOfflineRange): void {
		this.offlineRanges = [...this.offlineRanges, range];
		this.offlineRanges = sortBy(this.offlineRanges, [
			(item: JobDigitalLogOfflineRange) => moment(item.startDate).parseZone().format('YYYY-MM-DD')
		]).reverse();
	}

	public initializeInputFormGroup(): void {
		this.inputForm = new FormGroup({
			input: new FormControl(''),
			isReportDateRequired: new FormControl(false),
			keepDataUpTo: new FormControl(null)
		});
	}

	public initializeSearchFormGroup(): void {
		this.searchForm = new FormGroup({
			searchInput: new FormControl(null)
		});

		this.restoreInlineFilters();
	}

	public initializeDisabledFormGroup(): void {
		this.disabledFormGroup = new FormGroup({
			isChecked: new FormControl(true)
		});
	}

	public initializeConfirmationFormGroup(): void {
		this.confirmationFormGroup = new FormGroup({
			isChecked: new FormControl(false)
		});
	}

	public validateInput(): void {
		this.inputForm.get('input').valueChanges.subscribe(value => {
			if ((value as string)?.toLocaleLowerCase() === 'remove') {
				this.isConfirmEnable = true;
			} else {
				this.isConfirmEnable = false;
			}
		});
	}

	public onSpecifiedDateChange(event: MatCheckboxChange): void {
		if (event.checked) {
			this.isSpecifiedDateEnabled = true;
			this.inputForm.controls.keepDataUpTo.setValidators(Validators.required);
			this.inputForm.controls.keepDataUpTo.updateValueAndValidity();
		} else {
			this.isSpecifiedDateEnabled = false;
			this.inputForm.controls.keepDataUpTo.clearValidators();
			this.inputForm.controls.keepDataUpTo.updateValueAndValidity();
		}
	}

	public deleteOnDemandDLForm(jobDigitalLogFormRequest: JobDigitalLogFormRequest): void {
		this.isDeleteDisabled = true;
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		this.digitalLogService.deleteOnDemandDLForm(
			TokenHelper.getToken(this.activatedRoute),
			jobDigitalLogFormRequest.jobDigitalLogFormRequestId
		)
			.subscribe(res => {
				this.deleteFormByIndex(this.customFormRequestsList, jobDigitalLogFormRequest.jobDigitalLogFormRequestId);
				this.deleteFormByIndex(this.onDemandFormRequests, jobDigitalLogFormRequest.jobDigitalLogFormRequestId);
				this.deleteFormByIndex(this.actionableFormRequests, jobDigitalLogFormRequest.jobDigitalLogFormRequestId);
				this.isDeleteDisabled = false;
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			}, () => {
				GlobalSettingsService.isSecondaryLoaderLoading = false;
				ToastService.pushToast({
					icon: 'error',
					text: 'Delete could not be completed!',
					type: ToastType.Error
				} as Toast);
				this.isDeleteDisabled = false;
			});
	}

	public getOnDemandCompletedForms(callback: () => void): void {
		this.isLoading = true;
		
		this.digitalLogService.getFormRequests(TokenHelper.getToken(this.activatedRoute))
			.pipe(
				takeUntil(this.unsubscriber$)
			)
			.subscribe(result => {
				this.allFormRequests = result;
				this.onDemandFormRequests = this.allFormRequests.filter(item => item.isCompleted && item.recurrenceFrequencyId === Frequency.OnDemand);
				this.isLoading = false;

				callback();

			}, () => {
				this.isLoading = false;
			});
	}

	public deleteFormByIndex(formRequestsList: JobDigitalLogFormRequest[], jobDigitalLogFormRequestId: number): void {
		if (!formRequestsList || formRequestsList.length === 0) {
			return;
		}
		const index = formRequestsList.findIndex(job => job.jobDigitalLogFormRequestId === jobDigitalLogFormRequestId);
		if(index >= 0){
			formRequestsList.splice(index, 1);
		}
	}

	public checkNavigationBarActions(): void {
		if (GlobalSettingsService.navigationBarActions.size > 1) {
			GlobalSettingsService.navigationBarActions.forEach((button, key: string) => {
				button.isInDropdownMenu = key != 'site-notes-access-button';
			});
		}
	}

	private injectSiteNotesAccessButton(icon: string): void {
		GlobalSettingsService.navigationBarActions.set(
			'site_notes_access_button',
			{
				icon: icon,
				isCustomSvgIcon: true,
				listOrder: 0,
				isInDropdownMenu: false,
				isTextOnlyShownInDropdown: false,
				action: () => {
					GlobalSettingsService.navigationBarActions.clear();
					sessionStorage.setItem('digital-log-back-url', location.href);
					this.router.navigate([`${this.siteNotesUrl}/${this.job?.jobId}`]);
				}
			}
		);
	}

	private injectActionButtons(): void {
		let icon = 'site_notes';
		this.siteNotesService.getSiteNotesStatus(TokenHelper.getToken(this.activatedRoute)).subscribe({
			next: (status: number) => {
				switch (status) {
					case 1:
						icon = 'pin_blue';
						break;
					case 2:
						icon = 'pin_red_blue';
						break;
					case 3:
						icon = 'pin_red';
						break;
					default:
						break;
				}
				this.injectSiteNotesAccessButton(icon);
			},
			error: error => {
				this.injectSiteNotesAccessButton('pin');
			}
		});

		GlobalSettingsService.navigationBarActions.set(
			'add_onDemand_form',
			{
				action: () => {
					(this.onDemandForms.length !== 0) ? this.router.navigate(['add'], { relativeTo: this.activatedRoute.parent }) :
						this.emptyOnDemandLogsModal.open();
				},
				text: 'On Demand',
				isInDropdownMenu: false,
				isTextOnlyShownInDropdown: true,
				isCustomSvgIcon: true,
				icon: 'snowflake',
				listOrder: 1,
				isDisabled: this.isJobCancelled
			});
		if(this.canConfigureRounds) {
			GlobalSettingsService.navigationBarActions.set(
				'configure_rounds',
				{
					action: () => {
						(this.configOnDemandForms.length !== 0) ? this.router.navigate(['config'], { relativeTo: this.activatedRoute.parent }) :
							this.emptyConfigOnDemandLogsModal.open();
					},
					text: 'Settings',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					icon: 'settings',
					listOrder: 110,
					isDisabled: this.isJobCancelled
				});
		}

		if (this.job.hasDLReport){
			GlobalSettingsService.navigationBarActions.set(
				'generate_inspection_report',
				{
					action: () => {
						this.isReportSelectorVisible = true;
					},
					text: 'Generate Report',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					icon: 'generate_report_icon',
					isCustomSvgIcon: true,
					listOrder: 2,
					isDisabled: this.isJobCancelled
				});
		}

		if (!this.isShowCompletedOnly$.getValue()) {
			GlobalSettingsService.navigationBarActions.set(
				'DL_completed_only',
				{
					action: () => {
						this.onShowCompleted();
					},
					icon: 'forms_stack',
					isCustomSvgIcon: true,
					listOrder: 0,
					text: 'Historical (' + (this.onDemandFormRequests ? this.onDemandFormRequests.length : this.onDemandFormsCount).toString() + ')',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					isDisabled: this.isJobCancelled
				}
			);
		} else {
			GlobalSettingsService.navigationBarActions.set(
				'DL_completed_only',
				{
					action: () => {
						this.isShowCompletedOnly$.next(false);
						this.injectActionButtons();
						this.checkNavigationBarActions();
					},
					icon: 'forms_stack',
					isCustomSvgIcon: true,
					listOrder: 0,
					text: 'Active',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					isDisabled: this.isJobCancelled
				}
			);
		}
	}

	private onShowCompleted() {
		this.isShowCompletedOnly$.next(true);
		this.injectActionButtons();
		this.checkNavigationBarActions();
	}

	public hasBottomMessages(): boolean {
		if (this.customerPreferences.preferences.isJobAutoSkipped || this.customerPreferences.preferences.isNotificationDisabled) {
			return true;
		}
		return false;
	}

	public hasReturnButton(): boolean {
		if (!(this.customerPreferences.preferences.isJobAutoSkipped || this.customerPreferences.preferences.isNotificationDisabled || this.hasCustomReturnUrl)) {
			return true;
		}
		return false;
	}

	public resetConfirmationCheckbox(): void {
		this.confirmationFormGroup.patchValue({ isChecked: false });
	}

	public onSearchClear(input: string): void {
		switch (input) {
			case 'searchInput':
				this.searchForm.patchValue({ searchInput: '' });
				break;			
			default:
				break;
		}
	}

	public bindFilters(): void {
		this.searchForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
			this.filterForms();
		});

		this.isShowCompletedOnly$.subscribe(value => {
			const showCompletedOnly = !!value;

			this.setFormRequestsCopy(showCompletedOnly);
			this.filterForms();

			if (showCompletedOnly && this.allFormRequests == null) {
				this.getOnDemandCompletedForms(() => {
					if (!this.isShowCompletedOnly$.getValue()) {
						return;
					}

					this.setFormRequestsCopy(true);
					this.filterForms();
				});
			}
		});
	}
	public fallbackAlias(item: JobDigitalLogFormRequest): string | null {
		return !!item.aliasIndex ? `(item ${item.aliasIndex})` : null;
	}

	public formAlias(item: JobDigitalLogFormRequest): string | null {
		return item.recurrenceFrequencyId === Frequency.OnDemand
			? item.alias || this.fallbackAlias(item)
			: null;
	}

	private setFormRequestsCopy(showCompletedOnly: boolean): void {
		let datasource = [];

		if (!showCompletedOnly) {
			datasource = (this.actionableFormRequests || []).filter(item =>
				(!item.isCompleted && item.recurrenceFrequencyId === Frequency.OnDemand) || item.recurrenceFrequencyId !== Frequency.OnDemand);
		}
		else {
			datasource = orderBy(this.onDemandFormRequests || [], [
				(item: JobDigitalLogFormRequest) => item.lastLogEntry
			], ['desc']);
		}
		this.customFormRequestsListCopy = datasource;
	}

	private filterForms(): void {
		const filterData = this.searchForm.getRawValue();
		filterData.searchInput = filterData.searchInput?.toLocaleLowerCase();
		let datasource = this.customFormRequestsListCopy;

		if (!!filterData.searchInput) {
			datasource = datasource.filter((x) => {
				return (this.formAlias(x)?.toLocaleLowerCase().includes(filterData.searchInput))
					|| x.aliasIdentifier?.toLocaleLowerCase().includes(filterData.searchInput)
					|| x.formName?.toLocaleLowerCase().includes(filterData.searchInput);
			});
		}

		
		this.customFormRequestsList = datasource;
	}
	
	public onCloseReportSelector($event: any){
		this.isReportSelectorVisible = false;

		if (!!$event.postedMessage){
			ToastService.pushToast({
				icon: 'info',
				text: $event.postedMessage,
				type: ToastType.Info
			} as Toast);
		}
	}

	public clearDate(): void {
		this.inputForm.patchValue({ keepDataUpTo: null });
	}

	public reloadPage(): void {
		window.location.reload();
	}
	public setMyWorkToToday(selectedProfileGroupId?: number): void {
		this.startMyWorkProgress.isWorkStarting = true;
		this.digitalLogService.setMyWorkToToday(TokenHelper.getToken(this.activatedRoute), selectedProfileGroupId).subscribe((result) => {
			this.startMyWorkProgress.isWorkStarting = false;
			this.startMyWorkProgress.isWorkStarted = true;
			if (result.hasActiveFormRequests
				&& !result.newFormRequestsCount
				&& !result.overwrittenTimeSlotsCount
				&& !result.reactivatedFormsCount
			) {
				this.startMyWorkProgress.progressMessage = this.workStartedWithNoChangesMsg;
			}
			else {
				this.startMyWorkProgress.progressMessage = this.workStartedMsg;
			}
		}, error => {
			this.startMyWorkProgress.isWorkStarting = false;
			this.startMyWorkProgress.hasError = true;
			if(error.status === 401) {
				this.startMyWorkProgress.progressMessage = this.startMyWorkDeniedMsg
			}
			else {
				this.startMyWorkProgress.progressMessage = this.startMyWorkErrorMsg;
			}
		})
	}
	
	public consolidateMyWork(selectedProfileGroupId?: number): void {
		this.startMyWorkProgress.isWorkStarting = true;
		this.digitalLogService.consolidateMyWork(TokenHelper.getToken(this.activatedRoute), selectedProfileGroupId).subscribe((result) => {
			this.startMyWorkProgress.isWorkStarting = false;
			this.startMyWorkProgress.isWorkStarted = true;
			this.startMyWorkProgress.progressMessage = this.workStartedMsg;
		}, error => {			
			this.startMyWorkProgress.isWorkStarting = false;
			this.startMyWorkProgress.hasError = true;
			if(error.status === 401) {
				this.startMyWorkProgress.progressMessage = this.startMyWorkDeniedMsg
			}
			else {
				this.startMyWorkProgress.progressMessage = this.startMyWorkErrorMsg;
			}
		})
	}

	public handleClearRemainingWork(): void {
		this.clearRemainingWorkProgress = {
			progressMessage: this.clearStartedMsg, 
			isCleanInProgress: false, 
			isCleanCompleted: false, 
			hasError: false
		};
		this.clearRemainingWorkModal.open();
	}

	public clearRemainingWork(isFutureLogDateAllowed: boolean = false): void {
		// if there are forms where the log date is in the future, just warn the user and ask if he/she still wants to proceed or cancel
		if (!isFutureLogDateAllowed 
			&& this.actionableFormRequests
			&& this.actionableFormRequests.some(
				x => moment(x.lastLogEntry).isAfter(moment(this.today))
			)
		) {
			this.futureLogDateConfirmationModal.open();
			return;
		}

		this.clearRemainingWorkProgress = {
			progressMessage: 'Complete work in progress...', 
			isCleanInProgress: true, 
			isCleanCompleted: false, 
			hasError: false
		};

		this.digitalLogService.clearRemainingWork(TokenHelper.getToken(this.activatedRoute)).subscribe(() => {
			this.clearRemainingWorkProgress.isCleanInProgress = false;
			this.clearRemainingWorkProgress.isCleanCompleted = true;
			this.clearRemainingWorkProgress.progressMessage = 'Work completed!';
		}, error => {			
			this.clearRemainingWorkProgress.isCleanInProgress = false;
			this.clearRemainingWorkProgress.hasError = true;
			if(error.status === 401) {
				this.clearRemainingWorkProgress.progressMessage = this.clearRemainingWorkDeniedMsg;
			}
			else {
				this.clearRemainingWorkProgress.progressMessage = this.clearRemainingWorkErrorMsg;
			}
		})
	}

	public onDocumentsClick(event: any) {
		this.router.navigate(['documents'], { relativeTo: this.activatedRoute });
	}

	public proceedWithFutureLogDates(): void {
		this.futureLogDateConfirmationModal.hide();
		this.clearRemainingWork(true);
	}

	public closeFutureLogDateConfirmation(): void {
		this.clearRemainingWorkModal.hide();
		this.futureLogDateConfirmationModal.hide();
	}
}
